
import { MapLocation } from '@/types/location';

// INVICTUS FIGHTER Gym Locations
export const invictusFighterGyms: MapLocation[] = [
  {
    id: 34001,
    name: "INVICTUS FIGHTER - Riyadh (Al Wady)",
    type: "Gym",
    devices: 2,
    coordinates: [24.794721468462374, 46.70266629546864],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "15-47",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 34002,
    name: "INVICTUS FIGHTER - Riyadh (Al Yasmeen)",
    type: "Gym",
    devices: 2,
    coordinates: [24.82276894934658, 46.65872099117426],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "15-47",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 34003,
    name: "INVICTUS FIGHTER - Riyadh (Al Qirawan)",
    type: "Gym",
    devices: 2,
    coordinates: [24.835855601281448, 46.5982961787105],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "15-47",
    orientation: "Portrait",
    segment: "Fitness"
  }
];
